import script from "./MenuLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuLayout.vue?vue&type=script&setup=true&lang=js"

import "./MenuLayout.vue?vue&type=style&index=0&id=f7c815d8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7c815d8"]])

export default __exports__